import React, { useEffect } from 'react';
import { useForm, FormProvider as RHFFormProvider } from 'react-hook-form';
import { LoanFormData } from '../types';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { LOAN_TYPE } from '../../credit-report/constants';
import { cloneDeep, set } from 'lodash';
import { getDocuments } from '../../../redux/slices';
import { useDispatch } from 'react-redux';
import { addFileNameToDocuments } from '../helper';
import { DocumentType, documentMapping } from '../constants';

export const FormProvider = ({ children }: any) => {
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state: RootState) => state.authReducer);
  const methods = useForm<LoanFormData>({
    mode: 'onTouched',
    shouldUnregister: false,
  });
  const { leadData } = useSelector((state: RootState) => state.leadsReducer);

  useEffect(() => {
    if (leadData[LOAN_TYPE.businessLoan]?.extraInfo) {
      intializeForm();
    }
  }, [leadData[LOAN_TYPE.businessLoan]?.leadId]);

  function intializeForm() {
    const phone = userDetails.phone;
    const extraInfo = {
      ...leadData[LOAN_TYPE.businessLoan]?.extraInfo,
    };
    let extraInfoClone = cloneDeep(extraInfo);
    const callback = (docs: any) => {
      if (docs) {
        const bank_statement: Document[] = [];
        const gst_registeration_cert: Document[] = [];
        const other_docs: Document[] = [];
        addFileNameToDocuments(docs).filter((doc: any) => {
          if (doc.type === DocumentType.BANK_STATEMENT) {
            bank_statement.push(doc);
          } else if (doc.type === DocumentType.GST_REGISTERATION_CERT) {
            gst_registeration_cert.push(doc);
          } else if (Object.values(documentMapping).includes(doc.type)) {
            other_docs.push(doc);
          }
        });
        set(extraInfoClone, 'bank_statement', bank_statement);
        set(extraInfoClone, 'business.gst.certificate', gst_registeration_cert);
        set(extraInfoClone, 'otherRegistrationProof', other_docs);
      }
      methods.reset(extraInfoClone);
    };

    dispatch(getDocuments({ phone, callback }));
  }

  return <RHFFormProvider {...methods}>{children}</RHFFormProvider>;
};
